/** Local exports have their own allocation guard, including selections and rounded dimensions. */
export const LOCAL_RASTER_LIMITS = { pixels: 40_000_000, edge: 16_384 } as const;

export function rasterDimensions(size: { width: number; height: number }, scale: number) {
  const width = Math.ceil(size.width * scale);
  const height = Math.ceil(size.height * scale);
  if (![scale, width, height].every(Number.isFinite) || scale <= 0 || width < 1 || height < 1) {
    throw new Error('This selection has no exportable size.');
  }
  if (width > LOCAL_RASTER_LIMITS.edge || height > LOCAL_RASTER_LIMITS.edge || width * height > LOCAL_RASTER_LIMITS.pixels) {
    throw new Error(`The ${width.toLocaleString()} × ${height.toLocaleString()} px export is too large. Choose a smaller size (up to 40 megapixels and 16,384 px per side).`);
  }
  return { width, height };
}

export function rasterSizeFits(size: { width: number; height: number }, scale: number): boolean {
  try { rasterDimensions(size, scale); return true; } catch { return false; }
}
